import * as React from 'react';
import classnames from 'classnames';
import * as ActionCable from "@rails/actioncable";
import { useZustand } from 'use-zustand';
import { widgetStore } from './developer-wall/admin/store';
import { EditMode, ViewMode } from "./developer-wall/admin/partials";

window.App || (window.App = {});
window.App.cable = ActionCable.createConsumer();

function styles(mode) {
  return {
    root: classnames({
      'nv-devwall-image-selector': true,
      [`nv-devwall-image-selector--${mode}-mode`]: true,
    }),
    header: classnames('nv-devwall-image-selector__header'),
  }
}

function widgetComponent(mode) {
  const widgetModes = {
    ['edit']: EditMode,
    ['view']: ViewMode,
  };

  return widgetModes[mode] || widgetModes.view;
}

export default function (props) {
  const {submissionId, originalImage, mode} = props;
  const updateImages = useZustand(widgetStore,(state) => state.updateImages);
  const updateStatus = useZustand(widgetStore,(state) => state.updateStatus);
  const updateOriginalImage = useZustand(widgetStore,(state) => state.updateOriginalImage);
  const updateSelectedImageURL = useZustand(widgetStore,(state) => state.updateSelectedImageURL);
  const updateSelectedImageID = useZustand(widgetStore,(state) => state.updateSelectedImageID);

  React.useEffect(() => {
    updateOriginalImage(originalImage);
  }, []);

  React.useEffect(() => {
    App.cable.subscriptions.create({channel: "DeveloperWallImageGeneratorChannel", id: submissionId}, {
      connected() {
        console.log("Connected to the channel:", this.identifier);
      },
      disconnected() {
        // Nothing to do on disconnect.
      },
      received(data) {
        const {action} = data;
        const {submission = {}, images: generatedImages = []} = data;
        const selectedImage = generatedImages.reduce(((acc, item) => {
          if (item.selected) {
            acc = item
          }
          return acc;
        }), null);
        if (selectedImage) {
          updateSelectedImageID(selectedImage.id);
          updateSelectedImageURL(selectedImage.url);
        }
        console.log('Received:', data);
        switch (action) {
          case 'init':
            updateStatus(submission?.status);
            updateImages(generatedImages);
            break;
          case 'submitted':
            updateStatus(submission?.status)
            break;
          case 'generating_images':
            updateStatus('generating_images')
            location.reload();
            break;
          case 'images_generated':
            const {images} = data;
            updateImages(images);
            updateStatus('images_generated');
            break;
          case 'final_image_selected':
            updateStatus('final_image_selected');
            break;
        }
      },
    });
  }, [submissionId])

  const WidgetComponent = widgetComponent(mode);
  const css = styles(mode);

  return (
    <div className={css.root}>
      <div className={css.header}>Developer Wall Image Generator - Submission ID: {submissionId}</div>
      <WidgetComponent submissionId={submissionId}/>
    </div>
  );
}
